import React from "react";
import PropTypes from "prop-types";
import { Flex, Box } from "theme-ui";
import Icon from "./Icon";
import { colors } from "../../styles/theme";

const styles = {
  outerContainer: {
    width: "4rem",
    height: "4rem",
    borderRadius: "8px",
    p: "0.5rem",
  },
  iconContainer:{
    width: "3rem",
    height: "3rem",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "48px",
  }
};

const DisplayIcon = ({ theme, iconName, iconColor, iconStyles, pointerCursor }) => {
  return (
    <Box
      sx={{
        ...styles.outerContainer,
        ...iconStyles,
        backgroundColor: colors[`${theme}100`],
      }}
    >
      <Flex
        sx={{
          backgroundColor: colors[`${theme}Main`],
         ...styles.iconContainer,
        }}
      >
        <Icon name={iconName} color={iconColor} pointerCursor={pointerCursor} />
      </Flex>
    </Box>
  );
};

DisplayIcon.propTypes = {
  theme: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  iconStyles: PropTypes.object,
  pointerCursor: PropTypes.bool,
};

DisplayIcon.defaultProps = {
  theme: "primary",
  iconName: "AlertTriangle",
  iconColor: colors.white,
  iconStyles: {},
  pointerCursor: false,
};

export default DisplayIcon;
